const mediaType = (url) => {
  if (url === undefined || url.trim() === "") {
    return "";
  }
  if (url.indexOf("soundcloud.com") !== -1) {
    return "soundcloud";
  } else if (url.indexOf("youtube.com") !== -1 || url.indexOf("youtu.be") !== -1) {
    return "youtube";
  } else if (url.indexOf("bandcamp.com") !== -1) {
    return "bandcamp";
  } else if (url.indexOf("mixcloud.com") !== -1) {
    return "mixcloud";
  } else if (url.indexOf("open.spotify.com") !== -1) {
    return "spotify";
  } else {
    return "";
  }
};

const isSoundCloudMediaUrl = (track) => {
  if (track.sc_url && track.sc_url.indexOf("soundcloud") > -1) {
    return true;
  }
  return false;
};

const isSpotifyMediaUrl = (track) => {
  if (track.sc_url && track.sc_url.indexOf("open.spotify.com") > -1) {
    return true;
  }
  return false;
};

const isSoundCloudType = (track) => {
  return track.mediaType && track.mediaType === "soundcloud";
};

const isSpotifyType = (track) => {
  return track.mediaType && track.mediaType === "spotify";
};

const isYouTubeMediaUrl = (track) => {
  if (track.sc_url && (track.sc_url.indexOf("youtu.be") > -1 || track.sc_url.indexOf("youtube") > -1)) {
    return true;
  }
  return false;
};
const isYouTubeType = (track) => {
  return track.mediaType && track.mediaType === "youtube";
};

const isBandcampMediaUrl = (track) => {
  if (track.sc_url && track.sc_url.indexOf("bandcamp") > -1) {
    return true;
  }
  return false;
};

const isBandcampType = (track) => {
  return track.mediaType && track.mediaType === "bandcamp";
};

export {
  mediaType,
  isSoundCloudType,
  isSoundCloudMediaUrl,
  isBandcampMediaUrl,
  isBandcampType,
  isYouTubeType,
  isYouTubeMediaUrl,
  isSpotifyMediaUrl,
  isSpotifyType,
};
